// extracted by mini-css-extract-plugin
var _1 = "ApplicantFitCheckBlockSuggestion-moduleApplicantFitCheckBlockSuggestion__rvbKI";
var _2 = "ApplicantFitCheckBlockSuggestion-moduleaccept__yClYV";
var _3 = "ApplicantFitCheckBlockSuggestion-moduleactions__K4Nlk";
var _4 = "ApplicantFitCheckBlockSuggestion-moduledismiss__iovft";
var _5 = "ApplicantFitCheckBlockSuggestion-modulevalue__B0KTT";
export { _1 as "ApplicantFitCheckBlockSuggestion", _2 as "accept", _3 as "actions", _4 as "dismiss", _5 as "value" }
